// src/utils/fcmUtils.js
// Firebase Cloud Messaging Token Yönetimi

import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const VAPID_KEY = 'BCWHDjS6G9kK0bK5NaaBq9kNRLXelMQCnO7Qk_T7LJuXJVeX5_1c5vX7qQ3K8mX9xN2YzL4R6hS8tU0wA2B4';

let messaging = null;

const initMessaging = () => {
    if (!messaging && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
        try {
            const { getApp } = require('firebase/app');
            const app = getApp();
            messaging = getMessaging(app);
        } catch (error) {
            // Firebase henüz başlatılmamışsa sessizce null dön
            return null;
        }
    }
    return messaging;
};

export const requestNotificationPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            console.log('Bildirim izni verildi');
            return true;
        } else {
            console.log('Bildirim izni reddedildi');
            return false;
        }
    } catch (error) {
        console.error('Bildirim izni alınırken hata:', error);
        return false;
    }
};

export const getFcmToken = async () => {
    try {
        const msg = initMessaging();
        if (!msg) return null;

        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

        const token = await getToken(msg, {
            vapidKey: VAPID_KEY,
            serviceWorkerRegistration: registration
        });

        if (token) {
            console.log('FCM Token alındı:', token.substring(0, 20) + '...');
            return token;
        } else {
            console.log('FCM Token alınamadı');
            return null;
        }
    } catch (error) {
        console.error('FCM Token alınırken hata:', error);
        return null;
    }
};

export const saveTokenToFirestore = async (userId, token) => {
    if (!userId || !token) return false;

    try {
        const tokenId = token.substring(0, 20);
        const tokenRef = doc(db, 'users', userId, 'fcmTokens', tokenId);

        const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true;

        await setDoc(tokenRef, {
            token: token,
            platform: detectPlatform(),
            createdAt: serverTimestamp(),
            lastSeenAt: serverTimestamp(),
            pwaInstalled: isPWA,
            userAgent: navigator.userAgent.substring(0, 200)
        });

        console.log('FCM Token Firestore\'a kaydedildi');
        return true;
    } catch (error) {
        console.error('FCM Token kaydedilirken hata:', error);
        return false;
    }
};

export const removeTokenFromFirestore = async (userId, token) => {
    if (!userId || !token) return false;

    try {
        const tokenId = token.substring(0, 20);
        const tokenRef = doc(db, 'users', userId, 'fcmTokens', tokenId);
        await deleteDoc(tokenRef);
        console.log('FCM Token Firestore\'dan silindi');
        return true;
    } catch (error) {
        console.error('FCM Token silinirken hata:', error);
        return false;
    }
};

export const updateTokenLastSeen = async (userId, token) => {
    if (!userId || !token) return false;

    try {
        const tokenId = token.substring(0, 20);
        const tokenRef = doc(db, 'users', userId, 'fcmTokens', tokenId);
        await setDoc(tokenRef, { lastSeenAt: serverTimestamp() }, { merge: true });
        return true;
    } catch (error) {
        console.error('Token lastSeenAt güncellenirken hata:', error);
        return false;
    }
};

export const setupForegroundListener = (callback) => {
    try {
        const msg = initMessaging();
        if (!msg) return null;

        return onMessage(msg, (payload) => {
            console.log('Foreground mesaj alındı:', payload);
            if (callback) callback(payload);
        });
    } catch (error) {
        console.error('Foreground listener kurulurken hata:', error);
        return null;
    }
};

const detectPlatform = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) return 'android';
    if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
    if (/Windows/.test(ua)) return 'windows';
    if (/Mac/.test(ua)) return 'macos';
    if (/Linux/.test(ua)) return 'linux';
    return 'web';
};

export const initializePushNotifications = async (userId) => {
    if (!('Notification' in window)) {
        console.log('Bu tarayıcı bildirimleri desteklemiyor');
        return { success: false, reason: 'not_supported' };
    }

    const hasPermission = await requestNotificationPermission();
    if (!hasPermission) {
        return { success: false, reason: 'permission_denied' };
    }

    const token = await getFcmToken();
    if (!token) {
        return { success: false, reason: 'token_failed' };
    }

    const saved = await saveTokenToFirestore(userId, token);
    if (!saved) {
        return { success: false, reason: 'save_failed' };
    }

    return { success: true, token };
};
